/* unplugin-vue-components disabled */import { render } from "./compXinjiangCategory.vue?vue&type=template&id=295bcd58&scoped=true"
import script from "./compXinjiangCategory.vue?vue&type=script&lang=js"
export * from "./compXinjiangCategory.vue?vue&type=script&lang=js"

import "./compXinjiangCategory.vue?vue&type=style&index=0&id=295bcd58&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295bcd58"]])

export default __exports__